import React from 'react';
import { Link } from 'react-router-dom';

const DocumentFields = ({ selectedDocumentFields }) => {
  if (!selectedDocumentFields || selectedDocumentFields.length === 0) {
    return null;
  }

  // Mostrar máximo 8 campos, el resto se indica con "y X más"
  const maxVisible = 8;
  const visibleFields = selectedDocumentFields.slice(0, maxVisible);
  const hiddenCount = selectedDocumentFields.length - maxVisible;

  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <label className="form-label mb-0 fw-semibold">
          <i className="bi bi-list-check me-2 text-success"></i>
          Campos a Extraer
        </label>
        <span className="badge bg-success">{selectedDocumentFields.length} campos</span>
      </div>
      
      <div className="border rounded-3 p-3 bg-light">
        <div className="d-flex flex-wrap gap-2">
          {visibleFields.map((field, index) => {
            const tooltipText = field.especificacion 
              ? `${field.nombre}: ${field.especificacion}` 
              : field.nombre;
            
            return (
              <div 
                key={field.id} 
                className="badge bg-white text-dark border border-primary px-3 py-2 d-flex align-items-center horizontal-field-badge"
                style={{ fontSize: '0.7rem' }}
                title={tooltipText}
              >
                <span className="badge bg-primary me-2 field-number-badge">
                  {index + 1}
                </span>
                <span className="fw-medium">{field.nombre}</span>
                {field.tipo && (
                  <span className="badge bg-secondary ms-2 field-type-badge">
                    {field.tipo}
                  </span>
                )}
              </div>
            );
          })}
          
          {hiddenCount > 0 && (
            <div 
              className="badge bg-light text-muted border border-secondary px-3 py-2 d-flex align-items-center"
              style={{ fontSize: '0.7rem' }}
              title={`Ver todos los ${selectedDocumentFields.length} campos`}
            >
              <i className="bi bi-three-dots me-2"></i>
              <span className="fw-medium">y {hiddenCount} más</span>
            </div>
          )}
        </div>
        
        <div className="text-center mt-3 pt-3 border-top">
          <small className="text-muted">
            <i className="bi bi-info-circle me-1"></i>
            ¿Necesitas modificar estos campos? Ve a la sección de 
            <Link to="/configuracion" className="text-decoration-none fw-medium ms-1">
              <i className="bi bi-gear me-1"></i>Configuración
            </Link>
          </small>
        </div>
      </div>
    </div>
  );
};

export default DocumentFields;
